<template>
    <div class="all-details-views">
        <!-- 引入公共端头部组件 -->
        <headNav></headNav>
        <div class="details-show-box" v-if="isDetailShow == 1">
            <div class="all_banner">
                <a href="javascript:void(0)" onclick="zixun()">
                    <!-- <img src="/assets/img/all/courses/5/banner.jpg" alt="鸡蛋灌饼"> -->
                    <img :src="pageData[0].banner.src" :alt="pageData[0].banner.title">
                </a>
            </div>
            <!-- 报名优惠 -->
            <div class="apply-discounts-wrap">
                <ul class="apply-dis-title">
                    <li>
                        <p>报名优惠：<span>联系咨询老师了解优惠详情</span></p>
                        <!-- <p>热门指数：<span>★★★★★</span></p> -->
                        <p>热门指数：<span>{{ starNumberShow(pageData[0].starNumber) }}</span></p>
                    </li>
                    <li>
                        <a href="javascript:void(0)" onclick="zixun()">在线咨询</a>
                    </li>
                </ul>
                <div class="apply-dis-number">
                    <p><i></i>咨询人数：{{ randomNumber(2000,4000) }}</p>
                    <p><i></i>报名人数：{{ randomNumber(2000,4000) }}</p>
                </div>
                <div class="apply-dis-info">
                    <p><span>培训时间：</span>节假日不休，随到随学，学会为止</p>
                    <p><span>师资力量：</span>导师团队经验丰富、手把手授课</p> 
                    <p><span>培训模式：</span>小班制教学，情景化授课，全程实操</p>  
                </div>
            </div>
            <!-- 分割线 -->
            <div class="body-line"></div>
            <!-- 公共标题 -->
            <div class="details-title-wrap">
                <!-- <h1>沙县小吃培训成品展示</h1> -->
                <h1>{{ pageData[0].madeIn.title }}</h1>
                <p></p>
            </div>
            <!-- 成品展示 -->
            <div class="made-in-show-wrap">
                <ul>
    
                    <li v-for="item in pageData[0].madeIn.src" :key="item">
                        <a href="javascript:void(0)">
                            <img :src="item" alt="">
                        </a>
                    </li>
                    <!-- <li><a href="javascript:void(0)"><img src="/assets/img/all/courses/105/made-in-show/1.jpg" alt=""></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses/105/made-in-show/2.jpg" alt=""></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses/105/made-in-show/3.jpg" alt=""></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses/105/made-in-show/4.jpg" alt=""></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses/105/made-in-show/5.jpg" alt=""></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses/105/made-in-show/6.jpg" alt=""></a></li> -->
                </ul>
                <div class="public-in-cons">
                    <a href="javascript:void(0)" onclick="zixun()">美味学院学费贵吗？</a>
                    <a href="javascript:void(0)" onclick="zixun()">交了学费能学成吗？</a>
                    <a href="javascript:void(0)" onclick="zixun()">新手没经验能学吗？</a>
                    <a href="javascript:void(0)" onclick="zixun()">更多疑问在线咨询</a>
                </div>
            </div>
            <!-- 分割线 -->
            <div class="body-line"></div>
            <!-- 公共标题 -->
            <div class="details-title-wrap">
                <h1>餐饮行业</h1>
                <p></p> 
                <h2>商机可见的好选择</h2>
            </div>
            <!-- 餐饮行业 -->
            <div class="catering-industry-wrap">
                <ul>
                    <li> 
                        <i></i>
                        <h3>市场火热</h3>
                        <p>民以食为天的饮食文化，让餐饮成为热门行业。</p>
                    </li>
                    <li> 
                        <i></i>
                        <h3>快速上手</h3>
                        <p>美食导师手把手教学，操作简单，新手也能学。</p>
                    </li>
                    <li> 
                        <i></i>
                        <h3>收入可观</h3>
                        <p>技能型人才，创业＋就业，综合收入高于其他行业。</p>
                    </li>
                </ul>
                <div class="public-in-cons">
                    <a href="javascript:void(0)" onclick="zixun()">美食培训就业怎么样？</a>
                    <a href="javascript:void(0)" onclick="zixun()">学成后能不能开店？</a>
                    <a href="javascript:void(0)" onclick="zixun()">美味学院地址在哪？</a>
                    <a href="javascript:void(0)" onclick="zixun()">更多疑问在线咨询</a>
                </div>
            </div>
            <!-- 分割线 -->
            <div class="body-line"></div>
            <!-- 公共标题 -->
            <div class="details-title-wrap">
                <h1>理论+实践</h1>
                <p></p>
                <h2>真材实料学技术</h2>
            </div>
            <!-- 真材实料学技术 -->
            <div class="lean-skill-wrap">
                <ul>
                    <li>
                        <h3><span>A</span>理论学习</h3>
                        <p>1、开店流程讲解：店面选址、物资采购等。</p>
                        <p>2、制作讲解：原材料的选择、配方比例等。</p>
                    </li>
                    <li>
                        <h3><span>B</span>示范讲解</h3>
                        <p>1、老师亲身示范，讲解技术。</p>
                        <p>2、步骤分解，各个环节随时沟通。比例等。</p>
                    </li>
                    <li>
                        <h3><span>C</span>自我实践</h3>
                        <p>1、备原材料，老师耐心教学。</p>
                        <p>2、操作所有流程，制作出成品。</p>
                        <p>3、老师点评，学员反复实践达到开店水准。</p>
                    </li>
                </ul>
                <div class="public-in-cons">
                    <a href="javascript:void(0)" onclick="zixun()">店面开店选址攻略？</a>
                    <a href="javascript:void(0)" onclick="zixun()">食材费用全包吗？</a>
                    <a href="javascript:void(0)" onclick="zixun()">新手多久能够学会？</a>
                    <a href="javascript:void(0)" onclick="zixun()">更多疑问在线咨询</a>
                </div>
            </div>
            <!-- 分割线 -->
            <div class="body-line"></div>
            <!-- 公共标题 -->
            <div class="details-title-wrap">
                <h1>品牌有实力 学习有底气</h1>
                <p></p>
                <h2>美食培训连锁品牌 实力值得信赖</h2>
            </div>
            <!-- 品牌有实力 -->
            <div class="det-brand-wrap">
                <a href="javascript:void(0)"><img src="/assets/img/all/courses-conmon/det-brand-bg.jpg" alt="美食培训连锁品牌"></a>
                <div class="double-btn-wrap">
                    <a href="javascript:vodi(0)" onclick="zixun()">了解学费详情学费</a>
                    <a href="javascript:vodi(0)" onclick="zixun()">了解课程</a>
                </div>
            </div>
            <!-- 分割线 -->
            <div class="body-line"></div>
            <!-- 公共标题 -->
            <div class="details-title-wrap">
                <h1>口味正宗 自带高人气</h1>
                <p></p>
            </div>
            <!-- 人气口味 -->
            <div class="popularity-wrap">
                <ul>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses-conmon/popularity/1.jpg" alt="正宗美味，美味学院"></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses-conmon/popularity/2.jpg" alt="正宗美味，美味学院"></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses-conmon/popularity/3.jpg" alt="正宗美味，美味学院"></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses-conmon/popularity/4.jpg" alt="正宗美味，美味学院"></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses-conmon/popularity/5.jpg" alt="正宗美味，美味学院"></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses-conmon/popularity/6.jpg" alt="正宗美味，美味学院"></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses-conmon/popularity/7.jpg" alt="正宗美味，美味学院"></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses-conmon/popularity/8.jpg" alt="正宗美味，美味学院"></a></li>
                    <li><a href="javascript:void(0)"><img src="/assets/img/all/courses-conmon/popularity/9.jpg" alt="正宗美味，美味学院"></a></li>
                </ul>
                <div class="double-btn-wrap">
                    <a href="javascript:vodi(0)" onclick="zixun()">了解学费详情学费</a>
                    <a href="javascript:vodi(0)" onclick="zixun()">了解课程</a>
                </div>
            </div>
            <!-- 分割线 -->
            <div class="body-line"></div>
            <!-- 公共标题 -->
            <div class="details-title-wrap">
                <h1>推荐搭配产品</h1>
                <p></p>
            </div>
            <!-- 推荐搭配产品 -->
            <div class="recommend-products-wrap">
                <!-- 默认是3个一排显示,超过3个，添加one-line-two-show属性，如4个就一排显示2个， -->
                <ul :class="[{'one-line-two-show':pageData[0].recommendProducts.length<=3?false:true}]">
                    <li v-for="item in pageData[0].recommendProducts" :key="item.id" :data-id="item.id">
                        <a v-if="item.src != null" :href="item.src">
                            <img :src="item.img" :alt="item.title">
                            <h3>{{ item.title }}</h3>
                            <p>报名人数：<span>{{ randomNumber(2000,4000) }}</span></p>
                        </a>
                        <!-- 连接是空的时候显示咨询 -->
                        <a v-else href="javascript:void(0)" onclick="zixun()">
                            <img :src="item.img" :alt="item.title">
                            <h3>{{ item.title }}</h3>
                            <p>报名人数：<span>{{ randomNumber(2000,4000) }}</span></p>
                        </a>
                    </li>
                    <!-- <li>
                        <a href="/all/courses/132">
                            <img src="/assets/img/all/courses/105/recommend-products/1.jpg" alt="快餐特色创就业班">
                            <h3>快餐特色创就业班</h3>
                            <p>报名人数：<span>22672</span></p>
                        </a>
                    </li> -->
                </ul>
            </div>
            <!-- 分割线 -->
            <div class="body-line"></div>
            <!-- 公共标题 -->
            <div class="details-title-wrap">
                <h1>猜你想知道</h1>
                <p></p>
            </div>
            <!-- 猜你想知道 -->
            <div class="guess-like-wrap">
                <ul>
                    <li>
                        <h3>学习期间的原材料怎么算?</h3>
                        <p>
                            答：每一位学员在学习期间的所有原材料均由我们负责，您只需交学费即可，
                            除了学费<span>您无需再交任何其他费用</span>。
                        </p>
                    </li>
                    <li>
                        <h3>你们的培训模式是怎么样的?</h3>
                        <p>
                            答：<span>实操与理论相结合</span>，我们的每个课程在报名之后都会立即安排的教
                            学老师<span>面对面亲自示范</span>，会让学员<span>亲手实际操作，反复实践</span>，
                            直到学员做出和老师差不多的口味。
                        </p>
                    </li>
                    <li>
                        <h3>报名之前能不能先尝味道再学?</h3>
                        <p>答：<span>可以先品尝，满意后再学习</span>。部分品种准备时间较长，需提前预约。</p>
                    </li>
                </ul>
            </div> 
        </div>
        <!-- 404 -->
        <div class="under-construction-wrap" v-else>
            <img src="/assets/img/all/courses-conmon/ixon/404.png" alt="404">
            <h3>Sorry, there is no such page</h3>
            <p>页面正在加紧建设中...</p>
            <a href="javascript:void(0)" @click="back">返回上一页</a>
        </div>
        <!-- 公共底footer栏 -->
        <publicFoot></publicFoot>
    </div>
</template>

<script>
import headNav from "@/components/HeadNav"
import publicFoot from "@/components/PublicFoot" // foot 底部

import baseMixin from "@/mixins/baseMixin";

export default {
    name: 'all',
    mixins: [baseMixin],
    data() {
        return {
            isDetailShow: 1, // 默认显示
            pageID: '', // 页面id
            pageData: [
                {
					"id": "5",
					"type": "鸡蛋灌饼",
					"des":"中餐系列-鸡蛋灌饼",
                    "title": "鸡蛋灌饼",
                    "src": "/all/courses/5",
					"banner":{
                            "title": "鸡蛋灌饼",
                            "src": "/assets/img/all/courses/5/banner.jpg"
                    },
                    "starNumber": 5,
                    "madeIn":{
                        "title": "鸡蛋灌饼培训成品展示",
                        "src":[
                            "/assets/img/all/courses/5/made-in-show/1.jpg",
                            "/assets/img/all/courses/5/made-in-show/2.jpg",
                            "/assets/img/all/courses/5/made-in-show/3.jpg",
                            "/assets/img/all/courses/5/made-in-show/4.jpg",
                            "/assets/img/all/courses/5/made-in-show/5.jpg",
                            "/assets/img/all/courses/5/made-in-show/6.jpg"
                        ]
                    },
                    "recommendProducts":[
                        {
                            "title": "酱香饼培训",
                            "id": "148",
                            "src": "/all/courses/148",
                            "img": "/assets/img/all/courses/5/recommend-products/1.jpg"
                        },
                        {
                            "title": "山东杂粮煎饼培训",
                            "id": "212",
                            "src": "/all/courses/212",
                            "img": "/assets/img/all/courses/5/recommend-products/2.jpg"
                        },
                        {
                            "title": "煎饼果子培训",
                            "id": "186",
                            "src": "/all/courses/186",
                            "img": "/assets/img/all/courses/5/recommend-products/1.jpg"
                        }
                    ]
                }
            ]
        }
    },
    components:{
        headNav,
        publicFoot
    },
    methods:{
        back(){//返回上一层
            this.$router.go(-1);
        },
        /* 本地了解学费详情数据 */
        getLocalDataByFetch(callBack){
            fetch('/assets/json/courses.json')
                .then((res) => {
                    return res.json();
                })
                .then((data) => {
                    callBack && callBack(data);
                })
        },
        changePageByIndexFn(){ // 通过路径更换 详情页
            var This = this;
            var resultFilterData;
            this.getLocalDataByFetch(function(data){
                var list = This.filterDataType(data.coursesData,'courses');
                var pageIndex;
                if( This.$route.params.id ){
                    pageIndex = This.$route.params.id;
                }else{
                    pageIndex = This.pageID;
                }
                resultFilterData = list.filter((item)=>{
                    // console.log(item.id)
                    // return item.id.indexOf(pageIndex) != -1;
                    if(item.id == pageIndex){
                        return item.id == pageIndex;
                    }
                });
                if(!resultFilterData.length){
                    This.isDetailShow = 0;
                }else{
                    This.pageData = resultFilterData;
                    This.isDetailShow = 1;
                    // console.log(This.pageData[0].recommendProducts.length)
                }
                // console.log(resultFilterData.length)
            })
        },
        starNumberShow(num){ // 热门指数
            var star = "★";
            for(var i = 0;i < num-1;i++ ){
                star+=star[i];
            }
            return star;
        },
        randomNumber(x,y){ // 生成随机数
            return parseInt( Math.random()*(y-x)+x );
        }
    },
    mounted(){
        this.pageID = this.$route.params.id;
        this.changePageByIndexFn();
    }
}
</script>

<style lang="less" scoped>
@rem: 40rem;
@w100: 640/@rem;

.justify {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.auto(@w) {
    width: @w/@rem;
    margin: 0 auto;
}

// 圆角
.radius(@radius) {
    border-radius: @radius/@rem @radius/@rem @radius/@rem @radius/@rem;
}

.linefont(@lineHeight, @fontSize, @color) {
    line-height: @lineHeight/@rem;
    font-size: @fontSize/@rem;
    color: @color;
}

.backgroundUrl(@img) {
    background: url(@img) no-repeat center / contain;
}

.aimg(@h) {
    a {
        display: block;
        img {
            width: 100%;
            height: @h/@rem;
        }
    }
}

// vue闪烁问题
[v-cloak] {
    display: none;
}

.all_banner{
    a{
        display: block;
        img{
            width: 100%;
        }
    }
}

// 报名优惠
.apply-discounts-wrap{
    .auto(605);
    margin-top: 20/@rem;
    .apply-dis-title{
        &:extend(.justify);
        li{
            p{
                .linefont(38, 22, #363636);
                font-weight: bold;
                text-align: left;
                span{
                    .linefont(38, 22, #ea0510);
                    color: #ea0510;
                    font-weight: bold;
                }
            }
            a{
                display: block;
                width: 160/@rem;
                .linefont(45, 20, #fff);
                text-align: center;
                background: #ea0510;
                .radius(4);
                margin-top: 10/@rem;
            }
        }
    }
    .apply-dis-number{
        background: #f2f2f2;
        &:extend(.justify);
        .radius(4);
        padding: 10/@rem 0;
        margin-top: 15/@rem;
        p{
            flex: 1;
            .linefont(25, 20, #000);
            i{
                display: inline-block;
                width: 20/@rem;
                height: 20/@rem;
                .linefont(25, 20, #000);
                // background: #000;
                vertical-align: -3/@rem;
                margin-right: 5/@rem;
                .backgroundUrl('/assets/img/all/courses-conmon/ixon/zixun-icon.png');
            }
            &:nth-of-type(2){
                i{
                    .backgroundUrl('/assets/img/all/courses-conmon/ixon/baoming-icon.png');
                }
            }
            &:first-child{
                border-right: 1px solid #e4e4e4;
            }
        }
    }
    .apply-dis-info{
        text-align: left;
        margin-top: 15/@rem;
        p{
            .linefont(44, 22, #000);
            span{
                .linefont(44, 22, #6a6a6a);
            }
        }
    }
}

// 分割线
.body-line{
    height: 10/@rem;
    background: #f1f1f1;
    margin-top: 20/@rem;
}

// 公共标题
.details-title-wrap{
    padding-top: 15/@rem;
    h1{
        .linefont(66, 30, #2d0300);
        font-weight: bold;
    }
    p{
        width: 150/@rem;
        height: 2px;
        background: #2d0300;
        position: relative;
        top: -2/@rem;
        left: 50%;
        transform: translateX(-50%);
        &::after{
            content: '';
            display: block;
            width: 50/@rem;
            height: 5px;
            background: #2d0300;
            position: absolute;
            top: -1px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    h2{
        .linefont(56, 25, #000);
    }
}

// 成品展示
.made-in-show-wrap{
    margin-top: 20/@rem;
    ul{
        .auto(630);
        &:extend(.justify);
        li{
            width: 308/@rem;
            margin-bottom: 20/@rem;
            .aimg(203);
        }
    }
}
.public-in-cons{
    .auto(610);
    &:extend(.justify);
    margin-top: 20/@rem;
    a{
        display: block;
        width: 296/@rem;
        .linefont(56, 25, #000);
        border: 1px solid #eaeaea;
        .radius(6);
        margin-bottom: 20/@rem;
        &:last-child{
            background: #ea0510;
            color: #fff;
            border: 1px solid #ea0510;
        }
    }
}

// 餐饮行业
.catering-industry-wrap{
    ul{
        .auto(610);
        margin-top: 15/@rem;
        &:extend(.justify);
        li{
            width: 195/@rem;
            border-radius: 80px;
            background: #eeeeee;
            padding-bottom: 50/@rem;
            position: relative;
            i{
                display: block;
                .auto(176);
                height: 176/@rem;
                margin-top: 20/@rem;
                .backgroundUrl('/assets/img/all/courses-conmon/youshi1.png');
            }
            &:nth-of-type(2){
                i{
                    .backgroundUrl('/assets/img/all/courses-conmon/youshi2.png');
                }
            }
            &:nth-of-type(3){
                i{
                    .backgroundUrl('/assets/img/all/courses-conmon/youshi3.png');
                }
            }
            h3{
                .linefont(66, 30, #000);
                font-weight: bold;
            }
            p{
                .auto(142);
                .linefont(30, 23, #636363);
                text-align: center;
            }
            &::after{
                content: '';
                display: block;
                width: 30/@rem;
                height: 2px;
                background: #d85353;
                position: absolute;
                bottom: 25/@rem;
                left: 50%;
                transform: translateX(-50%);
            }
        };
    }
}

// 真材实料学技术
.lean-skill-wrap{
    ul{
        .auto(590);
        li{
            h3{
                .linefont(55, 30, #000);
                font-weight: bold;
                position: relative;
                text-align: left;
                text-indent: 70/@rem;
                margin-top: 20/@rem;
                margin-bottom: 20/@rem;
                span{
                    display: block;
                    width: 60/@rem;
                    height: 60/@rem;
                    .linefont(60, 24, #fff);
                    font-weight: bold;
                    background: #eb020e;
                    .radius(30);
                    position: absolute;
                    top: 0;
                    left: 0;
                    text-align: center;
                    text-indent: 0;
                }
            }
            p{
                .linefont(50, 22, #000);
                text-align: left;
                text-indent: 30/@rem;
            }
        }
    }
}

// 品牌有实力
.det-brand-wrap{
    margin-top: 15/@rem;
    padding-bottom: 30/@rem;
    .aimg(526);
}
.double-btn-wrap{
    .auto(600);
    margin-top: 20/@rem;
    &:extend(.justify);
    a{
        display: block;
        width: 295/@rem;
        .linefont(55, 22, #fff);
        background: #340a00;
        .radius(4);
        &:last-child{
            background: #ea0510;
        }
    }
}

// 人气口味
.popularity-wrap{
    ul{
        .auto(610);
        &:extend(.justify);
        li{
            width: 196/@rem;
            .aimg(129);
            margin-top: 10/@rem;
        }
    }
}

// 推荐搭配产品
.recommend-products-wrap{
    margin-top: 20/@rem;
    ul{
        .auto(600);
        &:extend(.justify);
        li{
            width: 190/@rem;
            .aimg(125);
            text-align: left;
            h3{
                .linefont(38, 20, #000);
                font-weight: bold;
            }
            p{
                .linefont(30, 20, #000);
                span{
                    .linefont(38, 18, #ea0510);
                }
            }
        }
    }
    ul.one-line-two-show{ // 列表数据大于3个的时候显示
        li{
            width: 290/@rem;
            margin-bottom: 15/@rem;
            .aimg(191);
        }
    }
}

// 猜你想知道
.guess-like-wrap{
    ul{
        .auto(600);
        text-align: left;
        li{
            h3{
                .linefont(60, 24, #fff);
                background: #feae3b;
                .radius(30);
                text-indent: 15/@rem;
                margin: 15/@rem 0;
            }
            p{
                .auto(580);
                .linefont(34, 20, #000);
                text-align: justify;
                span{
                    .linefont(34, 20, #ea0510);
                }
            }
        }
    }
}

// 404
.under-construction-wrap{
    margin-top: 40/@rem;
    padding-bottom: 40/@rem;
    img{
        display: block;
        .auto(220);
    }
    h3{
        .linefont(60, 30, #f95b07);
    }
    p{
        .linefont(60, 22, #29090a);
    }
    a{
        display: block;
        .auto(280);
        .linefont(45, 22, #fff);
        background: #fa8b51;
        .radius(4);
    }
}
</style>